(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-target-cro"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-ft-photo]');if(!button)return;const gallery=button.closest('.ft-gallery-shell').querySelector('.ft-gallery');const photo=gallery.children[Number(button.dataset.ftPhoto)];gallery.scrollTo({left:photo.offsetLeft-gallery.firstElementChild.offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["music-pad-cro"] && !Shopify.designMode) return;
  try {
    
const checkoutForm = document.getElementById('mp-product-form');
if (checkoutForm) {
  let submitting = false;
  checkoutForm.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (submitting || !checkoutForm.reportValidity()) return;
    submitting = true;
    const buttons = [...document.querySelectorAll('button[form="mp-product-form"], #mp-product-form button[type="submit"]')];
    const error = document.getElementById('mp-checkout-error');
    error.hidden = true;
    buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    checkoutForm.setAttribute('aria-busy', 'true');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(checkoutForm), headers: { 'Accept': 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Toevoegen is niet gelukt. Probeer het opnieuw.');
      window.location.assign(root + 'checkout');
    } catch (failure) {
      error.textContent = failure.message || 'Er ging iets mis. Probeer het opnieuw.';
      error.hidden = false;
      error.tabIndex = -1;
      error.focus();
      buttons.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
      checkoutForm.removeAttribute('aria-busy');
      submitting = false;
    }
  });
}

document.querySelectorAll('[data-mp-image]').forEach(button => button.addEventListener('click', () => { const image = document.getElementById('mp-main-image'); if (!image) return; image.src = button.dataset.mpImage; image.removeAttribute('srcset'); image.alt = button.dataset.mpAlt; document.querySelectorAll('[data-mp-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button))); }));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petorio-cro"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const b=event.target.closest('[data-pt-photo]');if(!b)return;const g=b.closest('.pt-media').querySelector('.pt-gallery');const target=g.children[Number(b.dataset.ptPhoto)];g.scrollTo({left:target.offsetLeft-g.firstElementChild.offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});

  } catch(e) { console.error(e); }
})();
})();
